import { render, staticRenderFns } from "./AccrualsEntityTabs.vue?vue&type=template&id=4f0c4827&scoped=true"
import script from "./AccrualsEntityTabs.vue?vue&type=script&lang=js"
export * from "./AccrualsEntityTabs.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEntityTabs.vue?vue&type=style&index=0&id=4f0c4827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c4827",
  null
  
)

export default component.exports